/// <reference path="../../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import * as JsonView from '../../actions/json-view';
import * as UIActions from '../../actions/ui';
import { jumpContext } from '../../actions/contexts.action';
import { setActiveProcess } from '../../actions/json-view';

export const InitialState = {
  activeItem: null,
  activeCaseRun: {} as CMxAPI.CaseRun,
  loading: true,
  locked: false
};

const reducer = createReducer(InitialState, (builder) => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState }));

  builder.addCase(JsonView.onLoad.fulfilled, (state, action) => {
    const { caseDetail, activeProcess } = action.payload;
    return {
      ...state,
      activeItem: caseDetail,
      activeCaseRun: activeProcess,
      loading: false
    };
  });

  builder.addCase(UIActions.parentDidNavigate.type, (state, action: any) => {
    return { ...state, locked: !action.payload };
  });

  builder.addCase(setActiveProcess, (state, action) => {
    return {
      ...state,
      activeCaseRun: action.payload
    };
  });
});

export default reducer;
